import { createAuthenticatedApiClient } from '../../../shared/api/apiClient';
import { rpcCall } from '../../../shared/api/rpcClient';
import { useAuth } from '../../auth/context/AuthContext';
import { useMemo } from 'react';
import type { CognitoUser, GroupUpdate, CedarPolicy } from '../../../types';

export { EDITABLE_GROUPS } from '../../../shared/constants/authorizationGroups';
export const ENTRA_GROUPS = ['msreportingadmin', 'msreportingusers', 'ticket-handler'];

export const createUserManagementService = (idToken: string) => {
  const client = createAuthenticatedApiClient(idToken);

  return {
    listUsers: async (): Promise<CognitoUser[]> => {
      return rpcCall<CognitoUser[]>(client, 'admin.ListUsers');
    },

    getUser: async (username: string): Promise<CognitoUser> => {
      return rpcCall(client, 'admin.GetUser', { username });
    },

    updateUserGroups: async (username: string, update: GroupUpdate): Promise<CognitoUser> => {
      return rpcCall(client, 'admin.UpdateUserGroups', {
        username,
        add_groups: update.add_groups,
        remove_groups: update.remove_groups,
      });
    },

    listPolicies: async (): Promise<CedarPolicy[]> => {
      return rpcCall<CedarPolicy[]>(client, 'admin.ListPolicies');
    },

    getPolicy: async (policyId: string): Promise<CedarPolicy> => {
      return rpcCall(client, 'admin.GetPolicy', { policy_id: policyId });
    },

  };
};

export const useUserManagementService = () => {
  const { idToken } = useAuth();

  return useMemo(() => {
    if (!idToken) {
      throw new Error('Not authenticated');
    }

    return createUserManagementService(idToken);
  }, [idToken]);
};
